
import { Vue } from "vue-class-component";

export default class CloseCircleFill extends Vue {}
